<template>
  <div class="row">
    <div class="col-md-12" v-for="url in urls">
      <div class="box box-primary">
        <div class="overlay" v-if="url.loading">
          <i class="fa fa-refresh fa-spin"></i>
        </div>
        <div class="box-header with-border">
          <h3 class="box-title">{{ url.title }}</h3>
          <button class="btn btn-default btn-xs pull-right"
                  @click.prevent="getAvertissement(url.url)">
            <i class="fa fa-refresh "></i>
          </button>
        </div>
        <div class="box-body">
          <table class="table table-hover table-responsive"
                 v-if="['clubWithLicenceIncomplete','clubWithLicenceButNoMembers','clubWithBetweenZeroAndTen'].includes(url.url)">
            <thead>
            <tr>
              <th>Numéro club</th>
              <th>Club</th>
              <th>Nombre de membres</th>
              <th>Statut</th>
              <th>Erreur détectée</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="result in url.result">
              <td>
                <router-link :to="{ name: 'Club', params: { club_id: result.id }}">
                  {{ result.numero_club }}
                </router-link>
              </td>
              <td>
                <router-link :to="{ name: 'Club', params: { club_id: result.id }}">
                  {{ result.club.toUpperCase() }}
                </router-link>
              </td>
              <td>{{ result.licences_membres_actives_at_date.length }} membre{{$pluralize(result.licences_membres_actives_at_date.length)}}</td>
              <td><span :class="{'text-green':result.isLicencie!=null, 'text-red':result.isLicencie==null}">{{ result.isLicencie != null ? "Licencie" : "Non-licencié" }}</span></td>

              <td v-if="url.url=='clubWithLicenceIncomplete'">Pas de licence active</td>
              <td v-if="url.url=='clubWithLicenceButNoMembers'">Pas de membres</td>
              <td v-if="url.url=='clubWithBetweenZeroAndTen'">Faible population</td>
            </tr>
            </tbody>
          </table>
          <table class="table table-hover table-responsive"
                 v-if="['clubWithoutCorrespondant','clubLicencieNotOnWebsite'].includes(url.url)">
            <thead>
            <tr>
              <th>Numéro club</th>
              <th>Club</th>
              <th>Nombre de membres</th>
              <th>Composition club</th>
              <th>Payement cotisation</th>
              <th>Erreur détectée</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="result in url.result">
              <td>
                <router-link :to="{ name: 'Club', params: { club_id: result.id }}">
                  {{ result.numero_club }}
                </router-link>
              </td>
              <td>
                <router-link :to="{ name: 'Club', params: { club_id: result.id }}">
                  {{ result.club.toUpperCase() }}
                </router-link>
              </td>
              <td>{{ result.licences_membres_actives_at_date.length }} membre{{$pluralize(result.licences_membres_actives_at_date.length)}}</td>
              <td><span :class="{'text-green':result.licence_active.inscription!=null, 'text-red':result.licence_active.inscription==null}">{{ result.licence_active.inscription != null ? "Reçu" : "Non-reçu" }}</span></td>
              <td><span :class="{'text-green':result.licence_active.payement!=null, 'text-red':result.licence_active.payement==null}">{{ result.licence_active.payement != null ? "Reçu" : "Non-reçu" }}</span></td>

              <td v-if="url.url=='clubWithoutCorrespondant'">Pas de correspondant</td>
              <td v-if="url.url=='clubLicencieNotOnWebsite'">Non-affiché sur le site</td>
            </tr>
            </tbody>
          </table>
          <table class="table table-hover table-responsive"
                 v-if="['clubMoniteurNotLicencied','clubMoniteurNotAdeps','clubMoniteurNotDan','clubMoniteurAdjointNotMSI','clubAffilieAnneePasseePasMaintenant'].includes(url.url)">
            <thead>
            <tr>
              <th>Numéro club</th>
              <th>Club</th>
              <th>Nombre de membres</th>
              <th>Moniteur</th>
              <th>Erreur détectée</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="result in url.result">
              <td>
                <router-link :to="{ name: 'Club', params: { club_id: result.id }}">
                  {{ result.numero_club }}
                </router-link>
              </td>
              <td>
                <router-link :to="{ name: 'Club', params: { club_id: result.id }}">
                  {{ result.club.toUpperCase() }}
                </router-link>
              </td>

              <td>{{ result.licences_membres_actives_at_date.length }} membre{{$pluralize(result.licences_membres_actives_at_date.length)}}</td>
              <td>
                <router-link
                  v-if="getMoniteur(result)"
                  :to="{ name: 'Member', params: { member_id: getMoniteur(result).id_membre }}">
                  {{ getMoniteur(result).membre.fullName }}
                </router-link>
                <span
                  v-if="!getMoniteur(result)"
                  class="text-red">
                  PAS DE MONITEUR
                </span>

              </td>
              <!--<td><span :class="{'text-green':result.licence_active.inscription!=null, 'text-red':result.licence_active.inscription==null}">{{result.licence_active.inscription!=null ? "Reçu" : "Non-reçu" }}</span></td>-->
              <!--<td><span :class="{'text-green':result.licence_active.payement!=null, 'text-red':result.licence_active.payement==null}">{{result.licence_active.payement!=null ? "Reçu" : "Non-reçu" }}</span></td>-->

              <td v-if="url.url=='clubMoniteurNotLicencied'">Moniteur non-licencié</td>
              <td v-if="url.url=='clubMoniteurNotAdeps'">Moniteur non-formé ADEPS (ou pas de données)</td>
              <td v-if="url.url=='clubMoniteurNotDan'">Moniteur pas ceinture noire (ou pas de données)</td>
              <td v-if="url.url=='clubMoniteurAdjointNotMSI'">Moniteur adjoint non-diplômé Moniteur Sportif Initiateur (ou pas de données)</td>
              <td v-if="url.url=='clubAffilieAnneePasseePasMaintenant'">Club non-affilié cette année</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import {mapGetters, mapActions} from 'vuex'

var _ = require('underscore')

var moment = require('moment')

export default {
  data() {
    return {
      urls: {
        clubWithLicenceIncomplete: {
          loading: false,
          url: "clubWithLicenceIncomplete",
          param: moment().year(),
          title: "Clubs dont la cotisation annuelle n’est pas payée",
          result: [],
        },
        clubWithLicenceButNoMembers: {
          loading: false,
          url: "clubWithLicenceButNoMembers",
          param: moment().year(),
          title: "Clubs licenciés sans membres",
          result: [],
        },
        clubWithBetweenZeroAndTen: {
          loading: false,
          url: "clubWithBetweenZeroAndTen",
          param: moment().year(),
          title: "Clubs entre 0 et 10 membres",
          result: [],
        },
        clubWithoutCorrespondant: {
          loading: false,
          url: "clubWithoutCorrespondant",
          param: null,
          title: "Clubs sans correspondants",
          result: [],
        },
        clubLicencieNotOnWebsite: {
          loading: false,
          url: "clubLicencieNotOnWebsite",
          param: null,
          title: "Clubs licencié et non-affichés sur le site",
          result: [],
        },
        clubMoniteurNotLicencied: {
          loading: false,
          url: "clubMoniteurNotLicencied",
          param: null,
          title: "Clubs dont le moniteur n'est pas licencié",
          result: [],
        },
        clubMoniteurNotAdeps: {
          loading: false,
          url: "clubMoniteurNotAdeps",
          param: null,
          title: "Clubs dont le moniteur n'est pas formé ADEPS",
          result: [],
        },
        clubMoniteurNotDan: {
          loading: false,
          url: "clubMoniteurNotDan",
          param: null,
          title: "Clubs dont le moniteur n'est pas ceinture noire",
          result: [],
        },
        clubMoniteurAdjointNotMSI: {
          loading: false,
          url: "clubMoniteurAdjointNotMSI",
          param: null,
          title: "Clubs dont le moniteur adjoint n'est pas diplômé Moniteur Sportif Initiateur",
          result: [],
        },
        clubAffilieAnneePasseePasMaintenant: {
          loading: false,
          url: "clubAffilieAnneePasseePasMaintenant",
          title: "Clubs affiliés en " + (moment().year() - 1) + " mais pas en " + moment().year(),
          result: [],
        },

      },

    }
  },
  props: {},
  computed: {
    ...mapGetters({
      getRoute: 'getRoute',
    }),

  },
  mounted: function () {
    _.each(this.urls, item => {
      this.getAvertissement(item);
    })
    // this.urls.forEach(item => {
    //     this.getAvertissement(item.url);
    // })
  },
  methods: {
    ...mapActions({
      setRecap: 'setRecap',
    }),
    containsUrls: function (url, arrayUrls) {
      // return arrayUrls.includes(url)
    },
    getMoniteur: function ($club) {
      // debugger
      return _.first(_.where($club.comite, {id_poste: 3}));
    },
    getAvertissement: function (item) {
      let self = this;
      this.urls[item.url].loading = true
      self.$http.get(this.getRoute('Avertissement.' + item.url) + (item.param != null ? item.param : "")).then((response) => {
        this.urls[item.url].result = response.body
        this.urls[item.url].loading = false
      }, (response) => {
      });
    },

  },
  beforeRouteUpdate(to, from, next) {
  },

  beforeRouteEnter(to, from, next) {
  },
  watch: {},
  components: {}
}
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/Avertissement/Avertissement_club.vue